import React from 'react'

import numeral from 'numeral'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, array, func, bool, number, string } from 'prop-types'

import SvgTriangleUIIcon from 'Pods/Shared/SvgTriangleUIIcon'

import { NOOP } from 'Utils/stableDefaults'

import Action from './Components/Action/Action'
import Price from './Components/Price/Price'

function CartItem({
  data,
  included,
  trackCartRemoveGA4,
  trackAddToCart = NOOP,
  isCartBelowThreshold,
  isCartAboveThreshold,
  shouldShowCartProgress,
  itemIndex = 0,
  listType = '',
  actionType = 'remove',
  useIncludedData = true,
  saleThreshold = 0,
  locale = 'en',
}) {
  const { discount, price, originalPrice, earnsStoreCredits, discountPercentage } = data.attributes

  const item = useIncludedData ? included.find((incl) => incl.id === data.relationships.item.data.id) : data

  const { title, url, imageThumb } = item.attributes
  const { url: imageUrl } = imageThumb

  return (
    <article className="product-list__item" id={`cart-box-item-${data.id}`}>
      <div className="product-list__item-preview">
        <a href={url} title={title}>
          {earnsStoreCredits && (
            <div className="product-list__item-badge">
              <SvgTriangleUIIcon type="wallet" color="light" size="tiny" />
            </div>
          )}
          {discount > 0 && (
            <div className="product-list__item-badge product-list__item-badge--discount">- {discountPercentage}%</div>
          )}
          <img alt={title} src={imageUrl} />
        </a>
      </div>
      <div className="product-list__item-content-wrapper">
        <div className="product-list__item-content">
          <header className="product-list__item-info">
            <h1 className="product-list__item-title">
              <a href={url}>{title}</a>
            </h1>
          </header>
          <div className="product-list__item-price-info">
            {discount > 0 && (
              <div
                className={classnames(
                  'product-list__item-original-price',
                  isCartBelowThreshold && 'product-list__item-original-price--uncrossed'
                )}
              >
                {numeral(originalPrice).format('$0.00')}
              </div>
            )}
            <div
              className={classnames(
                'product-list__item-price',
                isCartBelowThreshold && discount > 0 && 'product-list__item-price--grey',
                isCartAboveThreshold && discount > 0 && 'product-list__item-price--red',
                !shouldShowCartProgress && discount > 0 && 'product-list__item-price--red'
              )}
            >
              <Price
                isCartBelowThreshold={isCartBelowThreshold}
                isDiscountApplicable={discount > 0}
                price={numeral(price).format('$0.00')}
                threshold={saleThreshold}
                locale={locale}
              />
            </div>
          </div>
        </div>
        <Action
          data={data}
          trackCartRemoveGA4={trackCartRemoveGA4}
          trackAddToCart={trackAddToCart}
          itemIndex={itemIndex}
          listType={listType}
          actionType={actionType}
        />
      </div>
    </article>
  )
}

CartItem.propTypes = {
  data: object.isRequired,
  included: array.isRequired,
  trackCartRemoveGA4: func.isRequired,
  trackAddToCart: func,
  isCartBelowThreshold: bool.isRequired,
  isCartAboveThreshold: bool.isRequired,
  shouldShowCartProgress: bool.isRequired,
  itemIndex: number,
  listType: string,
  actionType: string,
  useIncludedData: bool,
  saleThreshold: number,
  locale: string,
}

export default CartItem
